// Service for the Attendance Dashboard "Mi equipo" — "Resumen del mes" "Atrasos"
// card (ASIS-5410 / REXASIS-009).
// GET /attendance/my-team/monthly-summary/tardiness-summary?cutoffCompanyId=1&monthlyCutId=1 —
// both query params are required: the company and monthly cutoff selected in the
// "Resumen del mes" filters panel (ASIS-5414).

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import { buildQueryString } from '@/api/shared';

import type {
  LC_GetMyTeamMonthlyTardinessSummaryOut,
  GetMyTeamMonthlyTardinessSummaryParams,
  MyTeamMonthlyTardinessSummary,
} from '../types/myTeamMonthlyTardinessSummary.types';
import { mapMyTeamMonthlyTardinessSummary } from '../mappers/myTeamMonthlyTardinessSummary.mapper';


export class MyTeamMonthlyTardinessSummaryService {
  async getSummary(
    params: GetMyTeamMonthlyTardinessSummaryParams,
    signal?: AbortSignal,
  ): Promise<ApiResponse<MyTeamMonthlyTardinessSummary>> {
    const query = buildQueryString({
      cutoffCompanyId: params.cutoffCompanyId,
      monthlyCutId: params.monthlyCutId,
    });
    const { ATTENDANCE_MY_TEAM_MONTHLY_SUMMARY_TARDINESS_SUMMARY } = API_CONFIG.ENDPOINTS;
    const endpoint = `${ATTENDANCE_MY_TEAM_MONTHLY_SUMMARY_TARDINESS_SUMMARY}${query}`;
    const response = await apiClient.get<LC_GetMyTeamMonthlyTardinessSummaryOut>(
      endpoint, { signal },
    );

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapMyTeamMonthlyTardinessSummary(response.data) };
  }
}

export const myTeamMonthlyTardinessSummaryService = new MyTeamMonthlyTardinessSummaryService();
